import { inputWidthPx } from "@freightsimple/ui-core/Controls/inputWidth";
import type { InputWidth } from "@freightsimple/ui-core/Controls/inputWidth";

/**
 * One width for every single-line control in the claim form.
 *
 * Each step used to pick its own: the currency dropdown was `md`, the piece
 * counts 120px, the amount 140px, and the condition and repairability
 * dropdowns took Dropdown's `full` default — so no two steps lined up. Pulling
 * the number here means a field can't drift on its own.
 *
 * Both forms of the same width, because the controls disagree on how to take
 * it: `token` for anything on ui-core's `InputWidth` scale (Dropdown,
 * TextInput), `px` for `DimensionInput`, which takes a number. They are one
 * export so the two can never be edited apart.
 *
 * Multi-line fields are deliberately not on this width — the description and
 * notes textareas stay `2xl`, since a paragraph needs a longer measure than a
 * piece count.
 */
export const claimsFieldWidth: { token: InputWidth; px: number } = {
  token: "md",
  // `fit` and `full` are the only tokens without a pixel value; `md` has one.
  px: inputWidthPx.md ?? 192,
};
